export default (length: number, n: number): string => n.toString().padStart(length, "0")
